var _defs, _path, _path2, _path3, _path4, _path5, _rect, _rect2, _path6, _path7, _path8, _rect3, _rect4, _path9, _rect5, _rect6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgImparcialidad(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Icons",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#f5333f;}.cls-2{fill:#011e41;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M363.77,125.8a186.28,186.28,0,0,0-230.14,0l-9.89-12.58a202.29,202.29,0,0,1,249.92,0Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M268.69,159h-16V143a4,4,0,1,0-8,0v16h-16V143a20,20,0,1,1,40,0Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M248.83,236.91a44,44,0,1,1,44-44A44,44,0,0,1,248.83,236.91Zm0-72a28,28,0,1,0,28,28A28,28,0,0,0,248.83,165Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M188.46,386.63H64.94a20,20,0,0,1,0-40H188.46a20,20,0,0,1,0,40Zm-123.52-24a4,4,0,0,0,0,8H188.46a4,4,0,0,0,0-8Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M126.7,430a76.86,76.86,0,0,1-72.64-51.74L69.18,373a60.86,60.86,0,0,0,115,0l15.12,5.23A76.87,76.87,0,0,1,126.7,430Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 148.59,
    y: 255.06,
    width: 16,
    height: 104.3,
    transform: "translate(-113.49 92.83) rotate(-24.55)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 44.66,
    y: 299.21,
    width: 104.3,
    height: 16,
    transform: "translate(-222.85 267.63) rotate(-65.45)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M126.7,269.48a28.69,28.69,0,1,1,28.69-28.69A28.72,28.72,0,0,1,126.7,269.48Zm0-41.38a12.69,12.69,0,1,0,12.69,12.69A12.7,12.7,0,0,0,126.7,228.1Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M435.06,386.63H311.54a20,20,0,0,1,0-40H435.06a20,20,0,1,1,0,40Zm-123.52-24a4,4,0,0,0,0,8H435.06a4,4,0,1,0,0-8Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M373.3,430a76.87,76.87,0,0,1-72.64-51.74L315.78,373a60.86,60.86,0,0,0,115,0l15.12,5.23A76.86,76.86,0,0,1,373.3,430Z"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 395.19,
    y: 255.06,
    width: 16,
    height: 104.3,
    transform: "translate(-91.19 195.3) rotate(-24.55)"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 291.26,
    y: 299.21,
    width: 104.3,
    height: 16,
    transform: "translate(-78.71 491.93) rotate(-65.45)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M373.3,269.48A28.69,28.69,0,1,1,402,240.79,28.72,28.72,0,0,1,373.3,269.48Zm0-41.38A12.69,12.69,0,1,0,386,240.79,12.7,12.7,0,0,0,373.3,228.1Z"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 124.17,
    y: 197.1,
    width: 91.34,
    height: 16,
    transform: "translate(-57.95 67.17) rotate(-19.18)"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 319.69,
    y: 159.43,
    width: 16,
    height: 91.34,
    transform: "translate(26.34 447.24) rotate(-70.83)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImparcialidad);
export default __webpack_public_path__ + "static/media/imparcialidad.d13c716ba75048cf430d3b930b8668d5.svg";
export { ForwardRef as ReactComponent };